export function appendVisitorIdToUrl() {
    const visitorid = window.analyticsdatalayer.visitorid || '-1';
    const url = new URL(window.location.href);
    url.searchParams.set('visitorid', visitorid);
    history.replaceState({}, '', url);
}
